import styled from 'styled-components';
import { Drawer } from '@mui/material';

import Menu from './Menu';
import { useSidebarContext } from './SidebarContext';

const StyledDrawer = styled(Drawer)<{ $isOpen?: boolean }>`
  .MuiPaper-root {
    position: relative;
    background: ${({ theme }) => theme.palette.background.default};
    border: none;
    width: ${({ $isOpen }) => ($isOpen ? 200 : 72)}px;
    transition: width 220ms ease-out;
  }
`;

function Sidebar() {
  const { items, isOpen } = useSidebarContext();

  if (!items?.length) {
    return null;
  }

  return (
    <StyledDrawer variant="permanent" $isOpen={isOpen}>
      <Menu items={items} />
    </StyledDrawer>
  );
}

export default Sidebar;
